import {Component, OnInit, ViewChild} from '@angular/core';
import {MatCheckbox, MatDialog, MatDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Item} from '../../item';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {environment} from '../../../environments/environment.prod';
import {DialogProgressComponent} from '../../shared/dialog/dialog-progress/dialog-progress.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AppComponent} from '../../app.component';
import {HttpClient} from '@angular/common/http';
import {ConfService} from '../../conf.service';
import {KongService} from '../../kong.service';
import {ActivatedRoute, Router} from '@angular/router';
import {EmailtemplateService} from '../../emailtemplate.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {Loggedin} from '../../authFilter/platformCentralAuth';
import {AuthService} from '../../user/auth.service';
import {PlatformAesService} from '../../user/platform-aes.service';
import {DialogModelSuccess} from '../../shared/dialog/dialog-success/model';
import {DialogSuccessComponent} from '../../shared/dialog/dialog-success/dialog-success.component';
import {DialogComponent} from '../../shared/dialog/dialog.component';
import * as CryptoJS from 'crypto-js';
import {SignupProgressDataService} from '../signup-progress/signup-progress-data.service';

@Component({
  selector: 'app-onboard-partner',
  templateUrl: './onboard-partner.component.html',
  styleUrls: ['./onboard-partner.component.scss']
})
export class OnboardPartnerComponent implements OnInit {

  @ViewChild('myCheckbox') private myCheckbox: MatCheckbox;


  partner = '';

  isLinear = true;
  firstFormGroup: FormGroup;
  time = 0;
  ciSelected = 'aws';

  hide = true;
  confirmHide = true;
  columns: any;
  siteName: string;
  languageSelected = 'en';
  regions: any;
  regionSelected = 'us-east-1';
  pageLoading = true;

  content: boolean;
  email: string;
  phoneNumber: string;
  token: string;
  couponName: string;
  errorMessage: string;
  item: Item = {} as Item;
  progress = 0;
  confirmPassword: string;
  startProgress = false;

  progressMessage: string;

  validation = false;
  validationMessage: string;
  languages: any;
  passwordValidationStatement = '';
  siteValidationStatement = '';

  vaults = [
    {'name': 'Default', 'logo': './assets/img/partnerOnboarding/api.png', 'description': 'apiplatform\'s encryption mechanism'},
    {
      'name': 'AWS Secrets Manager',
      'logo': './assets/img/partnerOnboarding/awsSecretsMng.png',
      'description': 'Secure your password through AWS Secrets manager'
    },
    {
      'name': 'Hashicorp Vault',
      'logo': './assets/img/partnerOnboarding/hashiCorpVault.jpg',
      'description': 'Secure your password in Hashicorp\'s vault'
    },
  ];

  installationType = 'standard'; // setting default as standard
  installationTypes = [
    {
      installation: 'Proceed with standard installation',
      key: 'standard'
    },
    {
      installation: 'I want to customize my own infrastructure',
      key: 'custom'
    }
  ];

  customInstallationScreen = false;

  partnerOnboardingPayload = {
    partner: '',
    email: '',
    environments: [
      {
        env: 'admin',
        password: '',
        dashboard: [
          {
            provider: 'apiplatform',
            cloud: 'aws'
          }
        ]
      },
      {
        env: 'dev',
        password: '',
        devex: [
          {
            provider: 'apiplatform',
            cloud: 'aws'
          }
        ],
        dashboard: [
          {
            provider: 'apiplatform',
            cloud: 'aws'
          }
        ],
        storage: [
          {
            provider: 'apiplatform',
            cloud: 'aws'
          }
        ],
        apigateway: [
          {
            provider: 'apiplatform',
            cloud: 'aws'
          }
        ],
        databases: [
          {
            connection_type: 'apiplatform',
            connection_name: 'default',
            database_type: 'mongodb'
          }
        ]
      }
    ]
  };

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  selectedVault = {
    'name': 'Default',
    'logo': './assets/img/partnerOnboarding/api.png',
    'description': 'apiplatform\'s encryption mechanism'
  };
  selectedOrganizationType: any;
  selectedAssistance = 'Application Development';
  assistanceObject = [];
  selectedUsageRequirements = [];
  selectedOrganizationPotential: any;
  selectedEnvironment = [];
  selectedInstallationType: any;
  isOneStepInstallation = true;


  URLObject = {};
  timesRan = 0;
  isVerified: boolean;

  environmentResponseArray = [];
  tempStatusVerification = 'created';
  isEnvironmentsCreationComplete = false;
  environmentCreationStart: boolean;

  containsDigit = false;
  containsLowerCase = false;
  containsUpperCase = false;
  containsSpecialCharacter = false;
  adminPkey: string;
  partnerShortCode: string;
  isChecked = true;
  showDefaultEnvironments = true;
  directNavigationToConsoleLoading = false;
  directNavigationToConsoleLoading1 = false;
  previousPartner = '';
  directNavigationEnvCreationComplete = false;
  previousId = 0;
  isPartnerAvailabilityCheckLoading = false;
  isValidPartnerShortcode = false;
  iterationCount = 1000;
  keySize = 128;
  passphrase = environment.cipheringPhrase;
  password: string;
  htmlContent = '';

  installingScreen = false;

  envPkeys = {};
  resendToken = false;
  mDialogRef: MatDialogRef<DialogProgressComponent, any>;
  isResendVerificationEmailSuccessful = false;
  resendVerificationRetries = 0;
  apiKeys: any;
  apiKeyData: any;
  apiKey: any;
  DNSValidationRetries = 0;

  constructor(public platform: LeftpanelComponent,
              private appComp: AppComponent,
              private httpClient: HttpClient,
              public dialog: MatDialog,
              private _formBuilder: FormBuilder,
              private confPost: ConfService,
              private kong: KongService,
              private router: Router,
              private Urlroute: ActivatedRoute,
              private emailTemplateInstance: EmailtemplateService,
              private _service: ConnecttocrudService,
              private signupDataService: SignupProgressDataService,
              private auth: Loggedin,
              private authService: AuthService,
              private encryptionDecryptionService: PlatformAesService) {
  }

  async ngOnInit() {

    const that = this;

    this.keySize = this.keySize / 32;

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
      secondCtrl: ['', Validators.required],
      orgSiteNameCtrl1: ['', Validators.required]
    });


    this.getLanguages();
    this.getCloudRegions();

    this.Urlroute.queryParams
        .subscribe(params => {
          if (params.emailId && params.token) {
            this.token = params.token;
            this.adminPkey = params.token;
            this.envPkeys['admin'] = this.adminPkey;
            this.email = params.emailId;
            // this.settingsPayload.environments[0].cloud[0].audit_logs[0].by = this.email;
            // this.settingsPayload.environments[0].services[0].configurations[0].audit_logs[0].by = this.email;
            // this.settingsPayload.environments[0].services[1].configurations[0].audit_logs[0].by = this.email;
            // this.settingsPayload.email = params.emailId;
            // this.settingsPayload.phone_number = params.phoneNumber;
            this.phoneNumber = params.phoneNumber;
            this.phoneNumber = this.phoneNumber.replace(/ /gi, '+');
            this.content = true;

            // Promise.all([platformServices, platformServiceCategories]).then(resp => {
            this.confPost.verifyToken(params.emailId, params.token).subscribe(data => {
              // (data);
              if (data.status === 200) {
                this.email = params.emailId;
                this.content = true;
              } else if (data.status === 208) {
                this.content = false;
                this.errorMessage = 'Token is invalid. Please sign up to continue';
              } else if (data.status === 401) {
                this.content = false;
                this.resendToken = true;
              }
              this.pageLoading = false;
            }, error => {
              if (error.status === 401) {
                this.content = false;
                this.resendToken = true;
              }
              this.pageLoading = false;
              this.errorMessage = 'Token is invalid. Please sign up to continue';
            });
            // });
          }
          if (params.couponName) {
            this.couponName = params.couponName;
          }
        });
  }

  setupCreationMessages() {
    this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Setting up partner account'});
    this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Creating user account'});
    this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'initial', info: 'Creating admin environment'});
    this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'initial', info: 'Setting up admin environment console dashboard'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Creating Development environment'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up development environment console'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up development environment devex'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up API gateway for development environment'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Setting up file storage for development environment'});
  }

  finishCreationMessages() {
    this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Setting up partner account'});
    this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Creating user account'});
    this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'success', info: 'Creating admin environment'});
    this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'success', info: 'Setting up admin environment console dashboard'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Creating Development environment'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up development environment console'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up development environment devex'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up API gateway for development environment'});
    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Setting up file storage for development environment'});
  }

  setupPartner(partnerCreationPayload) {
    this.customInstallationScreen = false;
    this.installingScreen = true;
    this.setupCreationMessages();
    this.confPost.createPartner(partnerCreationPayload).subscribe(response => {
        this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Validating created environments'});
        this.finishCreationMessages();
        let partnerResp: any;
        partnerResp = response;

        let environmentName = 'dev-' + this.partner;

        let domainFound = false;
        let domainName = '';

        if (partnerResp && partnerResp.environments) {
          const environmentItem = partnerResp.environments.find(
              (env) => !env.environment.startsWith('admin-') && env.infras.dashboard
          ) || partnerResp.environments.find((env) => env.environment.startsWith('admin-'));

          if (environmentItem && environmentItem.environment) {
            environmentName = environmentItem.environment;
            if (environmentItem.infras && environmentItem.infras.dashboard) {
              domainFound = true;
              domainName = environmentItem.infras.dashboard;
            }
          }
        }

      // tslint:disable-next-line:max-line-length
      setTimeout(() => {
        Promise.resolve(this.authService.generateAuthenticatorToken(environmentName, this.password, this.email)).then(async resp => {
          let authTokenContainer: any;
          authTokenContainer = resp;

          this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'success', info: 'Validating created environments'});

          if (domainFound) {
            Promise.resolve(this.platform.validateDNS([domainName])).then(resp1 => {
              const verified = false;
              this.authService.redirectWithAuthenticatorToken(verified, authTokenContainer.partner, authTokenContainer.token);
            }, error => {
              this.authService.redirectWithAuthenticatorToken(false, authTokenContainer.partner, authTokenContainer.token);
            });
          } else {
            this.authService.redirectWithAuthenticatorToken(false, authTokenContainer.partner, authTokenContainer.token);
          }
        }, error => {
          this.platform.openSnackBar('Unable to log in to your account at the moment. Please login with your credentials.', 'Error', {
            duration: 4000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          setTimeout(() => {
            this.router.navigateByUrl('/auth/login');
          }, 5000);
        });
      }, 1000);

    }, error => {
      this.platform.handleErrorGracefully(error, 'Unable to create your account at the moment. Please try again.');
      this.signupDataService.logsKey.splice(0, this.signupDataService.logsKey.length);
      if (this.installationType === 'standard') {
        this.installingScreen = false;
        this.customInstallationScreen = false;
      } else {
        this.installingScreen = false;
      }
    });
  }

  constructPayload(partner, email, password, config) {
    const partnerOnboardingPayload = JSON.parse(JSON.stringify(this.partnerOnboardingPayload));

    partnerOnboardingPayload.partner = partner;
    partnerOnboardingPayload.email = email;
    partnerOnboardingPayload.environments.forEach(env => {
      for (const [key, value] of Object.entries(env)) {
        if (key !== 'env' && key !== 'password') {
          const configValue = config[key];
          if (configValue !== undefined) {
            if (Array.isArray(configValue) && configValue.length > 0) {
              Object.assign(value, configValue);
            } else if (Array.isArray(configValue) && configValue.length === 0) {
              env[key] = [];
            } else if (configValue && typeof configValue === 'object') {
              Object.assign(value, configValue);
            }
          }
        } else if (key === 'password') {
          env[key] = password;
        }
      }
    });
    return partnerOnboardingPayload;
  }

  createPartner() {
    this.passwordPolicyValidator().then(response => {
      if (response && (this.password === this.confirmPassword)) {
        if (this.installationType === 'standard') {
          const payload = (this.constructPayload(this.partner, this.email, this.password, {}));
          this.setupPartner(payload);
        } else if (this.installationType === 'custom') {
          this.customInstallationScreen = true;
        }
      } else {
        this.platform.openSnackBar('Please make sure that your password follows our password policy.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }, error => {});
  }

  customInstallationOnProceed(config) {
    const payload = (this.constructPayload(this.partner, this.email, this.password, config));
    this.setupPartner(payload);
  }

  customInstallationCancelled() {
    this.customInstallationScreen = false;
  }

  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  openSuccess(response: string) {
    const alert: DialogModelSuccess = new DialogModelSuccess(
        response,
        '',
        null,
        null
    );

    this.mDialogRef = this.dialog.open(DialogSuccessComponent, {
      data: alert,
      disableClose: false
    });
  }

  resendVerification(payload) {
    this.confPost.resendVerificationEmail(payload).subscribe(async response => {
      this.isResendVerificationEmailSuccessful = true;
      this.pageLoading = false;
      this.openSuccess('Activation link has been successfully resent to your registered email. Please click on the link to complete the onboarding process.');
    }, async error => {
      this.resendVerificationRetries += 1;
      if (this.resendVerificationRetries <= 5) {
        setTimeout(() => {
          this.resendVerification(payload);
        }, 5000);
      } else {
        let errorMessage = '';
        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
          errorMessage = error.error.message;
        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
          errorMessage = error.error;
        } else {
          errorMessage = 'Error while resending activation link.';
        }
        await this.platform.notifyErrorToAdmins({error: 'Error while resending activation link for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while checking notify error to admins endpoint.', payload);
        this.platform.openSnackBar('Error while resending activation link. Sorry for the inconvenience. Please try again sometime.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.router.navigateByUrl('/auth/signup');
        this.pageLoading = false;
      }
    });
  }

  resendVerificationLink() {
    this.pageLoading = true;
    const payload = {
      email: this.email,
      phoneNumber: this.phoneNumber,
      token: this.token
    };
    this.resendVerification(payload);
  }

  encrypt(salt, iv, passPhrase, plainText, keySize, iterationCount) {
    const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
    const encrypted = CryptoJS.AES.encrypt(
        plainText,
        key,
        {iv: CryptoJS.enc.Hex.parse(iv)});
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  resetFlags() {
    this.isPartnerAvailabilityCheckLoading = false;
    this.isValidPartnerShortcode = false;
  }

  isContainsAlphaNumericInPartner() {
    return new Promise((resolve, reject) => {
      let i = 0;
      let character = '';
      let isContainsAlphabet = false;
      if (this.partner && this.partner !== null && this.partner !== undefined && this.partner !== '') {
        while (i <= this.partner.length) {
          character = this.partner.charAt(i);
          if ((character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) || (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122)) {
            isContainsAlphabet = true;
          }
          i++;
          if (i === this.partner.length) {
            if (isContainsAlphabet) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
        }
      }
    });
  }

  validatePartnerShortcode() {
    this.partner = this.partner.toLowerCase();
    Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.partner)).then(resp1 => {
      if (resp1 === true) {
        this.isPartnerAvailabilityCheckLoading = false;
        this.isValidPartnerShortcode = false;
        this.siteValidationStatement = '';
        if (this.previousPartner !== this.partner) {
          if (this.previousPartner === '') {
            this.isPartnerAvailabilityCheckLoading = true;
            // Check partner exist or not
            this.appComp.reservationCollectionPayload.partner = this.partner;
            this.confPost.checkPartnerShortcodeExistence(this.appComp.reservationCollectionPayload).subscribe(response => {
              if (response && response !== undefined && response !== null) {
                this.isPartnerAvailabilityCheckLoading = false;
                if (response && response !== null && response !== undefined && response['message'] === false) {
                  // Throw error partner already exists
                  this.siteValidationStatement = 'Partner with this name already exists';
                } else {
                  Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
                    if (resp) {
                      this.siteValidationStatement = '';
                      this.isValidPartnerShortcode = true;
                    } else {
                      this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
                    }
                  });
                  // Partner is available
                  // Entry in services collection
                  if (this.previousId !== 0) {
                    const tempPayload = {
                      forcedExpiration: true
                    };
                    this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                      // assign ID created to previousId
                      this.previousId = response['id'];
                    }, async error => {
                      await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
                    });
                  } else {
                    // assign ID created to previousId
                    this.previousId = response['id'];
                  }
                  this.previousPartner = JSON.parse(JSON.stringify(this.partner));
                }
              }
            }, async error => {
              let errorMessage = '';
              if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                errorMessage = error.error.message;
              } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                errorMessage = error.error;
              } else {
                errorMessage = 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.';
              }
              await this.platform.notifyErrorToAdmins({error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending error message to admins while checking partner short code existence during onboarding.', {error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'});
            });
          } else {
            if (this.partner === '') {
              this.siteValidationStatement = 'Partner name is required';
              // if (this.previousId !== 0) {
              const tempPayload = {
                forcedExpiration: true
              };
              this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                this.previousId = response1['id'];
              }, async error => {
                await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
              });
              // } else {
              // assign ID created to previousId
              // this.previousId = response['id'];
              // }
              this.previousPartner = JSON.parse(JSON.stringify(this.partner));
            } else {
              this.isPartnerAvailabilityCheckLoading = true;
              this.appComp.reservationCollectionPayload.partner = this.partner;
              this.confPost.checkPartnerShortcodeExistence(this.appComp.reservationCollectionPayload).subscribe(response => {
                this.isPartnerAvailabilityCheckLoading = false;
                if (response && response !== null && response !== undefined && response['message'] === false) {
                  // Throw error partner already exists
                  this.siteValidationStatement = 'Partner with this name already exists';
                } else {
                  Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
                    if (resp) {
                      this.siteValidationStatement = '';
                      this.isValidPartnerShortcode = true;
                    } else {
                      this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
                    }
                  });
                  // Partner is available
                  // Entry in services collection
                  if (this.previousId !== 0) {
                    const tempPayload = {
                      forcedExpiration: true
                    };
                    this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                      // assign ID created to previousId
                      this.previousId = response['id'];
                    }, async error => {
                      await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
                    });
                  } else {
                    // assign ID created to previousId
                    this.previousId = response['id'];
                  }
                  this.previousPartner = JSON.parse(JSON.stringify(this.partner));
                }
              }, async error => {
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                  errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                  errorMessage = error.error;
                } else {
                  errorMessage = 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending error message to admins while checking partner short code existence during onboarding.', {error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'});
              });
            }
          }

        } else {
          if (this.partner !== '') {
            Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
              if (resp) {
                this.siteValidationStatement = '';
                this.isValidPartnerShortcode = true;
                this.isPartnerAvailabilityCheckLoading = false;
              } else {
                this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
              }
            });
          } else {
            this.siteValidationStatement = 'Partner name is required';
          }

        }
      } else {
        this.platform.openSnackBar('Partner name should not have any special characters or spaces in between', 'Error', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    });
  }

  selectVault(index) {
    this.selectedVault = this.vaults[index];
    // this.settingsPayload.partner_settings.secretsManager[0].type = this.selectedVault['name'];
    for (let i = 0; i < this.vaults.length; i++) {
      const id = 'vault' + i;
      if (index === i) {
        $('#' + id).css('border', '1px solid #ff672d');
      } else {
        $('#' + id).css('border', 'transparent');
      }
    }
  }

  showWhatsThis() {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: 'What is Partner Name?',
        message: 'A Partner Name is a short code used to create an account for the partner being signed up. The entire infrastructure including platform console, gateway manager, developer experience, development environments, file storage and database will be setup based on this name'
      }
    });
  }

  passwordPolicyValidator() {
    return new Promise((resolve, reject) => {
      let i = 0;
      let character = '';
      if (this.password.length < 8) {
        resolve(false);
      } else {
        while (i <= this.password.length) {
          character = this.password.charAt(i);
          if (character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57) {
            this.containsDigit = true;
          }
          if (character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) {
            this.containsUpperCase = true;
          }
          if (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122) {
            this.containsLowerCase = true;
          }
          if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
              character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
              character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
              character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
            this.containsSpecialCharacter = true;
          }
          i++;
          if (i === this.password.length) {
            if (this.containsDigit && this.containsLowerCase && this.containsUpperCase && this.containsSpecialCharacter) {
              resolve(true);
            } else {
              resolve(false);
            }
          }
        }
      }
    });
  }

  resetPasswordValidationStatement() {
    this.passwordValidationStatement = '';
  }

  validatePassword() {
    this.passwordPolicyValidator().then(response => {
      if (response) {
        if (this.passwordValidationStatement === '' && this.siteValidationStatement === '') {
        }
      } else {
        this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
      }
    });
  }

  async validateDNSDashboard(payload, maxTries, duration) {
    for (let i = 0; i < maxTries; i++) {
      if (this.tempStatusVerification !== 'verified') {
        await this.resolveDNSValidation(payload, maxTries, duration).then(response => {
          if (this.tempStatusVerification === 'verified') {
            return;
          }
        });
      }
    }
    // this.tempStatusVerification = 'not verified';
    return this.tempStatusVerification;
  }

  resolveDNSValidation(payload, maxTries, duration) {
    return new Promise(async (resolve, reject) => {
      await setTimeout(() => {
        this.confPost.dnsValidation(payload).subscribe(response => {
          if (response) {
            const responseFromApi = response;
            if (responseFromApi['body']['response'][0]['status']) {
              this.tempStatusVerification = 'verified';
            } else {
              this.tempStatusVerification = 'not verified';
            }
            resolve(this.tempStatusVerification);
          }
        }, async error => {
          this.DNSValidationRetries += 1;
          if (this.DNSValidationRetries !== maxTries) {
            this.resolveDNSValidation(payload, maxTries, duration).then(response1 => {
              if (response1) {
                this.tempStatusVerification = JSON.stringify(response1);
                resolve(this.tempStatusVerification);
              }
            });
          } else {
            this.DNSValidationRetries = 0;
            let errorMessage = '';
            if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
              errorMessage = error.error.message;
            } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
              errorMessage = error.error;
            } else {
              errorMessage = 'Error while validating DNS for this email : ' + this.email + ' while onboarding.';
            }
          }
        });
      }, duration);
    });
  }

  omit_special_char(event) {

    this.partner = this.partner.toLowerCase();
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
    //     this.item['partner'] = this.partner;
    // }
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
    // if (k !== 45) {
    //     this.item['partner'] = this.partner;
    // }
    // return (k !== 45);
  }

  getItem() {
    // this.confPost.getPartnerOnboard().subscribe(
    //     items => {
    //       const itemunit = items[0];
    //       this.columns = [];
    //       for (const itemval in itemunit) {
    //         this.columns.push(itemval);
    //       }
    //     },
    //     error => {
    //       // this.platform.openSnackBar('Error while getting item' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
    //       //     duration: 5000,
    //       //     verticalPosition: 'top',
    //       //     horizontalPosition: 'center'
    //       // });
    //     }
    // );
  }

  getLanguages() {
    this.confPost.getLanguages().subscribe(
        items => {
          this.languages = items;
        },
        error => {
          this.platform.openSnackBar('Error while getting list of languages' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
    );
  }

  getCloudRegions() {
    this.confPost.getCloudRegions().subscribe(
        items => {
          this.regions = items;
        },
        error => {
          this.platform.openSnackBar('Error while getting list of cloud regions' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
    );
  }

  navigateTODashboard() {
    for (const environment of this.environmentResponseArray) {
      if (environment['type'] === 'admin') {
        for (const URLObject of environment['URLs']) {
          if (URLObject['type'] === 'dashboard') {
            if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
              window.location.href = 'https://' + URLObject['url'] + '/console';
            } else {
              window.location.href = environment.platformRedirectURL + '/console';
            }
          }
        }
      }
    }
    // window.location.href = '/console';
    // this.router.navigate(['/controlplane']);
  }

}
